import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-argon',
  templateUrl: './argon.component.html',
  styleUrls: ['./argon.component.css']
})
export class ArgonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
